declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, IvfEmbryoTransferAttemptByCycleCodeController, IvfEmbryoTransferAttemptByCycleCodeRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleEmbryoTransferredController, IvfCycleEmbryoTransferredRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbGradingEditModal } from './gradingedit.modal';
import { NgbTrEtEditModal } from './tretedit.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'gradingview',
    templateUrl: './gradingview.component.html',
    styleUrls: ['./gradingview.component.scss'],
  animations: [routerTransition()]
})

export class GradingViewComponent implements OnInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
    @Input() DisplayName: string;
    //@Input() mode: string;
    @Input() GradingModel: string;
    searchTitle: string;
    public CanLoadReport: boolean = true;
  //
  //public FormattedCode: number = 0;
    public IsSetAccessRights: boolean;
    public FrozenCount: number;
    public TotalCount: number;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public LMPDate: Date;
  public ReceipientActorCode: number;
  public TransferDateNew: Date;
  TransferEndDate: NgbDateStruct;
  public ActivityCodenew: number;
  //
    CurrentIvfEmbryoTransferAttemptByCycleCodeController: IvfEmbryoTransferAttemptByCycleCodeController[];
    EmbryoTransFerEndInfo: IvfEmbryoTransferAttemptByCycleCodeController;
    CurrentIvfEmbryoTransferAttemptByCycleCodeRequest: IvfEmbryoTransferAttemptByCycleCodeRequest;
    LoadEmbryoTransfer() {
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest = new IvfEmbryoTransferAttemptByCycleCodeRequest();
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.ConditionalOperator = 1;
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfEmbryoTransferAttemptByCycleCodeController();
    }
    GetIvfEmbryoTransferAttemptByCycleCodeController() {
        this.StartRefreshing();

       // this.spinner.show();
        this.actorservice.GetIvfEmbryoTransferAttemptByCycleCodeController(this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIvfEmbryoTransferAttemptByCycleCodeController = this.ApiResData.Result;
                  this.EmbryoTransFerEndInfo = this.CurrentIvfEmbryoTransferAttemptByCycleCodeController[0];
                  this.TransferDateNew = this.CurrentIvfEmbryoTransferAttemptByCycleCodeController[0].TransferDate;
                  if (this.EmbryoTransFerEndInfo.TransferEndDate != null) {
                    var SValidFrom = new Date(this.EmbryoTransFerEndInfo.TransferEndDate);
                    if (SValidFrom.getFullYear() > 1900) {
                      console.log('this.UpdateDate >1990');
                      this.TransferEndDate = {

                        year: SValidFrom.getFullYear(),
                        month: SValidFrom.getMonth() + 1,
                        day: SValidFrom.getDate()
                      }
                    }
                  }
                   
                    this.stopRefreshing();
                  //  this.spinner.hide();
                    this.LoadSingle();
                }
                else {
                    this.stopRefreshing();
                   
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
    FrozenData: SingleWellCultureByCycleCodeController[];
    CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
    LoadSingle() {

        this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
      this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.CycleCode
        this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
        this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetSingleWellCultureByCycleCodeController()
    }
    GetSingleWellCultureByCycleCodeController() {
        this.StartRefreshing();


        this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;
                    this.TotalCount = this.CurrentSingleWellCultureByCycleCodeController.length;
                    this.FrozenData = this.ApiResData.Result;
                    var FrozenList = this.FrozenData.filter(
                        function (b) {
                            return b.IsFrozen == true;
                        });
                    this.FrozenData = FrozenList;
                    this.FrozenCount = this.FrozenData.length;

                   
                    this.stopRefreshing();
                   
                    this.LoadPatients();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    //alert("pickup");
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ReceipientActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.LMPDate = this.SelectedTreatmentCycle.LMP;
          
          this.stopRefreshing();
          this.LoadMasterReq();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
  ActivityCodeInfo: TreatmentCycleActiityMasterController;
  CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

  LoadMasterReq() {
    //alert("Data")
    this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCycleActiityMasterController();
  }

  GetTreatmentCycleActiityMasterController() {
    this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
    this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadTestData();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.GetCycleActivity(this.ActorCode, this.ScanDate);

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
 
  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

  LoadTestData() {
    //alert("ScansData")
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
      this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.EmbryoTransFerEndInfo.TreatmentCycleCode;
      this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
      this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    this.ActivityCodenew = this.CurrentIvfCycleTestByCodeRequest.ActivityCode;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();          

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
    }
    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
            }
        )

    }
    CurrentIvfCycleEmbryoTransferredController: IvfCycleEmbryoTransferredController[];
    CurrentIvfCycleEmbryoTransferredRequest: IvfCycleEmbryoTransferredRequest;

    LoadDropletEmbryoData() {
        //alert("ScansData")
        this.CurrentIvfCycleEmbryoTransferredRequest = new IvfCycleEmbryoTransferredRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleEmbryoTransferredRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleEmbryoTransferredController();
    }

    GetIvfCycleEmbryoTransferredController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleEmbryoTransferredRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleEmbryoTransferredRequest.ConditionalOperator = 10;
        // this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleEmbryoTransferredController(this.CurrentIvfCycleEmbryoTransferredRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleEmbryoTransferredController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  constructor(private router: Router, public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
      private modalService: NgbModal, private spinner: NgxSpinnerService,) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
   
      this.LoadEmbryoTransfer();
      this.LoadDropletEmbryoData();
      this.LoadPatients();
      this.LoadCycles();
//this.LoadPatients2();
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
   
  

    //alert(this.ActorCode);

   
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  

  

  

 
  
  //
 
  //

  
 



  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 
  closeResult: string;
  // This function is used in open
 
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })
      
  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
    GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
        if (l.DocID1 != null) {
            return l.DOC1
        }
        else if (l.DocID2 != null) {
            return l.DOC2
        }
        else if (l.DocID3 != null) {
            return l.DOC3
        }
        else if (l.DocID4 != null) {
            return l.DOC4
        }
        else if (l.DocID5 != null) {
            return l.DOC5
        }
        else if (l.DocID6 != null) {
            return l.DOC6
        }
        return 0;

    }

    GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
        if (l.Grade6 != null) {
            return l.Grade6
        }
        else if (l.Grade5 != null) {
            return l.Grade5
        }
        else if (l.Grade4 != null) {
            return l.Grade4
        }
        else if (l.Grade3 != null) {
            return l.Grade3
        }
        else if (l.Grade2 != null) {
            return l.Grade2
        }
        else if (l.Grade1 != null) {
            return l.Grade1
        }
        return "";

    }

    GetMaxImageUrl(l: SingleWellCultureByCycleCodeController): string {
        if (l.DocID6 != null) {
            return l.DocFriendlyName6
        }
        else if (l.DocID5 != null) {
            return l.DocFriendlyName5
        }
        else if (l.DocID4 != null) {
            return l.DocFriendlyName4
        }
        else if (l.DocID3 != null) {
            return l.DocFriendlyName3
        }
        else if (l.DocID2 != null) {
            return l.DocFriendlyName2
        }
        else if (l.DocID1 != null) {
            return l.DocFriendlyName1
        }
        return null;

    }
    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    GradingData: TreatmentCycleStatusController[];
    GradingData2: TreatmentCycleStatusController;
    EmbryoTransferData: TreatmentCycleStatusController[];
    EmbryoTransferData2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.GradingData = this.ApiResData.Result;
                    this.EmbryoTransferData = this.ApiResData.Result;
                    var gardinglist = this.GradingData.filter(
                        function (c) {
                            return c.PhaseActivity == "Embryo Grading";
                        });
                    this.GradingData = gardinglist;
                    this.GradingData2 = this.GradingData[0];

                    var embryotransferlist = this.EmbryoTransferData.filter(
                        function (g) {
                            return g.PhaseActivity == "Embryo Transfer";
                        });
                    this.EmbryoTransferData = embryotransferlist;
                    this.EmbryoTransferData2 = this.EmbryoTransferData[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    //this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
    EditGrading() {
        const modalRef = this.modalService.open(NgbGradingEditModal,
            {
                centered: true,
                size: "xl",
                keyboard: false,
                backdrop: 'static'

            })

        modalRef.componentInstance.CycleCode = this.CycleCode; /*this.GetCycleCode(s.FollicularGrowth)[0].TreatmentCycle*/
        //modalRef.componentInstance.FollicularGrowthCode = s.FollicularGrowth;
        //modalRef.componentInstance.ActivityCode = s.CycleActivity;
       // modalRef.componentInstance.PatientCode = this.SelectedTreatmentCycle2.EggPatientRegistrationNo;
        modalRef.componentInstance.Eggsourcetype = this.SelectedTreatmentCycle.EggSourceType;
        modalRef.componentInstance.ActorCode = this.ActorCode;
        //modalRef.componentInstance.OocyteQualityCode = this.OqaDetailsData.OocyteQualityCode;
        //modalRef.componentInstance.DOC = s.DOC;
        modalRef.componentInstance.GradingModel = this.GradingModel;
        modalRef.result.then((val: string) => {
            //alert(val);
            if (val == "Load") {
                this.LoadEmbryoTransfer();
            }

        });
    }
    EditEt() {
        const modalRef = this.modalService.open(NgbTrEtEditModal,
            {
                centered: true,
                size: "xl",
                keyboard: false,
                backdrop: 'static'

            })

        modalRef.componentInstance.CycleCode = this.CycleCode; /*this.GetCycleCode(s.FollicularGrowth)[0].TreatmentCycle*/
      
        modalRef.componentInstance.Eggsourcetype = this.SelectedTreatmentCycle.EggSourceType;
        modalRef.componentInstance.ActorCode = this.ActorCode;
       
        modalRef.componentInstance.GradingModel = this.GradingModel;
        modalRef.result.then(x => { this.GetIvfEmbryoTransferAttemptByCycleCodeController() })
        modalRef.result.then((val: string) => {
            //alert(val);
            if (val == "Load") {
                this.LoadEmbryoTransfer();
            }
          
        });
    }

    Top() {
        let m = document.querySelector("#top");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Bottom() {
        let m = document.querySelector("#bottom");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
  printgrading() {
    this.printService.printDocument2(this.SelectedTreatmentCycle.OwnerFormattedCode, 0

    );
    this.printService.printDocument("embryogradingdroplet",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, ActorCodedata: this.SelectedTreatmentCycle.EggActorCode, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
      }
    );
  }
  printfet() {
    this.printService.printDocument2(this.SelectedTreatmentCycle.OwnerFormattedCode, 0

    );
    this.printService.printDocument("fet",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, ActorCodedata: this.SelectedTreatmentCycle.EggActorCode, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
      }
    );
  }

}
